import React, { useCallback, useEffect, useRef, useState } from "react";
import { CategoryListService } from "../../services/ContactUS/CategoryListService";
import { SubCategoryListService } from "../../services/ContactUS/SubCategoryListService";
import { SubChildCategoryListService } from "../../services/ContactUS/SubChildCategoryListService";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ChannelPartnersService } from "../../services/ContactUS/ChannelPartnersService";
import { SetupDIYService } from "../../services/ContactUS/SetupDIYService";
import { Enums } from "../../constants/enums";
import { WatchoComplaintService } from "../../services/ContactUS/WatchoComplainService";
import axios from "axios";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { SubmitWatchoComplainAndFeedbackService } from "../../services/ContactUS/SubmitWatchoComplainAndFeedbackService";
import { confirmDialog } from "primereact/confirmdialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { OTTSubscriberService } from "../../services/ContactUS/OTTSubscriberService";
import configUAT from "../../config/ConfigUAT.json";
import config from "../../config/config.json";

import { AvailableCouponService } from "../../services/ContactUS/AvailableCouponService";
import { ValidateCouponService } from "../../services/ContactUS/ValidateCouponService";
import { AuthorizeService } from "../../services/ContactUS/AuthorizeService";
import { END_URL } from "../../constants/endUrl";

export const UseHookContactUS = () => {
  const toast = useRef(null);

  const [formFieldAction, setformFieldAction] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [ButtonAction, setButtonAction] = useState("");
  const [tabHelpActive, setTabHelpActive] = useState("active");
  const [tabTicketActive, setTabTicketActive] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubChildCategory, setSelectedSubChildCategory] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [selectedCategoryText, setSelectedCategoryText] = useState("");
  const [selectedSubCategoryText, setSelectedSubCategoryText] = useState("");
  const [selectedSubChildCategoryText, setSelectedSubChildCategoryText] =
    useState("");
  const [selectedPartner, setSelectedPartner] = useState("");
  const [selectedOTTPlans, setSelectedOTTPlans] = useState("");
  const [selectedCouponfield, setSelectedCouponfield] = useState(false);
  const [selectedSorcefield, setSelectedSorcefield] = useState(false);

  const [image, setImage] = useState(null);
  const [uploadImage, setuploadImage] = useState(null);
  const [a_t, setAt] = useState(null);
  const [eid, setEid] = useState(null);
  const [sid, setSid] = useState(null);
  const [mno, setMno] = useState(null);

  const [queryString, setQueryString] = useState(null);

  //set response of API
  const [category, setCategory] = useState();
  const [subCategory, setSubCategory] = useState(null);
  const [subChildCategory, setSubChildCategory] = useState(null);
  const [stepDIY, setStepDIY] = useState(null);
  const [ChannelPartners, setChannelPartners] = useState(null);
  const [WatchoComplaint, setWatchoComplaint] = useState(null);
  const [oTTPlans, setOTTPlans] = useState(null);
  const [AvailableCoupon, setAvailableCoupon] = useState(null);
  const [validateCoupon, setValidateCoupon] = useState(null);
  const [linkUrl, setLinkUrl] = useState("");
  const [visible, setVisible] = useState(false);
  const [typebutton, setTypebutton] = useState("");
  const [buttonColor, setbuttonColor] = useState("");
  const [purchasedBy, setPurchasedBy] = useState("");

  const [dialogData, setDialogData] = useState({
    header: "",
    message: "",
    icon: "",
    severity: "error", // success, info, warn, error
  });

  //Call the service API
  const CategoryService = useRef(CategoryListService());
  const SubCategoryService = useRef(SubCategoryListService());
  const SubChildCategoryService = useRef(SubChildCategoryListService());
  const SetpDIYService = useRef(SetupDIYService());
  const ChannelPartnerService = useRef(ChannelPartnersService());
  const WatchoComplainService = useRef(WatchoComplaintService());
  const SubmitWatchoComplainFeedbackService = useRef(
    SubmitWatchoComplainAndFeedbackService(),
  );
  const OTTSubscribersService = useRef(OTTSubscriberService());
  const SearchAvailableCouponService = useRef(AvailableCouponService());
  const SearchValidateCouponService = useRef(ValidateCouponService());
  const AuthValidateService = useRef(AuthorizeService());
  const navigate = useNavigate();
  const [couponCode, setCouponCode] = useState("");
  const [getConfig, setConfig] = useState(config);
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname === "ancillary.vzy.one") {
      setConfig(config);
    } else if (hostname === "beta-watchoancillary.dishtv.in") {
      setConfig(configUAT);
    } else {
      setConfig(config);
    }
  }, []);
  const showDialog = (type, message) => {
    const types = {
      success: {
        header: "",
        message: message,
        icon: "",
        severity: "success",
      },
      error: {
        header: "",
        message: message,
        icon: "",
        severity: "danger",
      },
    };
    setVisible(true);
    setDialogData(types[type]);
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setQueryString(queryString);
    const atParam = urlParams.get("a_t");
    const eidParam = urlParams.get("eid");
    const sidParam = urlParams.get("sid");
    let mnoParam = urlParams.get("mno");

    if (atParam) setAt(atParam);
    if (eidParam) setEid(eidParam);
    if (sidParam) setSid(sidParam);

    if (mnoParam) {
      if (mnoParam.indexOf("-") >= 0) {
        const temp = mnoParam.split("-");
        mnoParam = temp[1];
      }
      setMno(mnoParam);

      Auth(mnoParam, sidParam, "Web", atParam);
      GetUserDetails(mnoParam, atParam);
    }

    //sid, eid, queryString
  }, []);

  const handleIPLGTMTaggingOnLanding = useCallback(
    async (dataLayerJson = {}) => {
      window.dataLayer.push(dataLayerJson);
    },
    [],
  );

  const watchoTabOnclick = useCallback(
    async (tabtype, e, resetForm) => {
      try {
        e.preventDefault();

        if (tabtype === "help") {
          setTabHelpActive(Enums.Active);
          setTabTicketActive("");
          setWatchoComplaint(null);
          setCategory(null);
          setIsDisabled(false);
          setSelectedCouponfield(false);
          setformFieldAction(false);
          setSubCategory(null);
          setSubChildCategory(null);
          setIsDisabled(true);
          setChannelPartners(null);
          setStepDIY(null);
          setLinkUrl("");
          resetForm();
          GetCategoryList();
        } else {
          setSelectedCouponfield(false);
          setCategory(null);
          setIsDisabled(false);
          setformFieldAction(false); //Enabled/Disbled Submit Form while user select dropdown
          setChannelPartners(null);
          setStepDIY(null);
          setLinkUrl("");
          setSubCategory(null);
          setSubChildCategory(null);
          setIsDisabled(true);

          resetForm();
          const payload = { OttSMSId: sid };
          const response =
            await WatchoComplainService?.current.WatchoComplaintList(payload);
          if (response) {
            setWatchoComplaint(response?.data);
            setTabTicketActive(Enums.Active);
            setTabHelpActive("");
          } else {
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong",
              life: 3000,
              className: "Contactpage-toast",
            });
          }
        }
        let dataLayerJson = {
          event: "past_tickets",
          help_link: window.location.href,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails?.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails?.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
        navigate(`/Help/help-support${queryString}`, { replace: true });
      } catch (error) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong",
          life: 3000,
          className: "Contactpage-toast",
        });
      }
    },
    [sid, queryString, a_t, mno, userDetails],
  );

  const GetCategoryList = useCallback(async () => {
    try {
      setSelectedCategory("");
      setSubChildCategory(null);
      const payload = {};
      const response = await CategoryService?.current.CategoryList(payload);
      setCategory(response.data);
      setSelectedSubCategory("");
    } catch (error) {}
  }, []);

  const OnChangeCategory = useCallback(
    async (e, text) => {
      try {
        setCouponCode("");
        setSelectedCouponfield(false);
        setIsDisabled(false);
        setformFieldAction(false); //Enabled/Disbled Submit Form while user select dropdown
        setChannelPartners(null);
        setStepDIY(null);
        setLinkUrl("");
        setSubCategory(null);
        setSubChildCategory(null);
        setSelectedCategory(e.target.value);
        setSelectedSubCategory("");
        setSelectedSubChildCategory("");
        setuploadImage(null);
        const payload = { parentCategoryId: e.target.value };
        const response =
          await SubCategoryService?.current.SubCategoryList(payload);
        setSubCategory(response.data);
        setSelectedCategoryText(text);

        let dataLayerJson = {
          event: "help_category",
          help_link: window.location.href,
          help_category: text,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
      } catch (error) {}
    },
    [selectedCategoryText, userDetails, a_t, mno, sid],
  );

  const OnChangeSubCategory = useCallback(
    async (e, text) => {
      try {
        setCouponCode("");
        setChannelPartners(null);
        setStepDIY(null);
        setLinkUrl("");
        setSubChildCategory(null);
        setSelectedSubChildCategory("");
        setSelectedPartner("");
        setSelectedCouponfield(false);
        setformFieldAction(false); //Enabled/Disbled Submit Form while user select value
        setSelectedSubCategory(e.target.value);
        setuploadImage(null);
        GetSubChildCategory(e);
        setSelectedSubCategoryText(text);

        let dataLayerJson = {
          event: "help_subcategory",
          help_link: window.location.href,
          help_category: selectedCategoryText,
          help_subcategory: text,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
      } catch (error) {}
    },
    [
      selectedCategory,
      selectedCategoryText,
      selectedSubCategoryText,
      a_t,
      mno,
      sid,
      userDetails,
    ],
  );

  const GetSubChildCategory = useCallback(
    async (e) => {
      try {
        setStepDIY(null);
        setLinkUrl("");
        setuploadImage(null);
        const payload = { parentCategoryId: e.target.value };
        const response =
          await SubChildCategoryService?.current.SubChildCategoryList(payload);

        setSubChildCategory(response.data);
        const text = e.target.options[e.target.selectedIndex].text;
        if (e.target.value === getConfig.general_Feedback_Suggestion) {
          setformFieldAction(true);
        } else if (
          response.data.responseList.length === 0 &&
          selectedCategory === getConfig.signIn_Login_Issues
        ) //Sign In/Login Issues
        {
          const parentCategoryId = selectedCategory;
          const CategoryId = e.target.value;
          const SubSubCategoryId = "0";

          GetChannelpartners(
            parentCategoryId,
            CategoryId,
            SubSubCategoryId,
            "",
            text,
          );
          setButtonAction(Enums.Yes_NO);
        } else if (response.data.responseList.length === 0) {
          const parentCategoryId = selectedCategory;
          const CategoryId = e.target.value;
          const SubSubCategoryId = "0";
          GetChannelpartners(
            parentCategoryId,
            CategoryId,
            SubSubCategoryId,
            "",
            text,
          );
        }
      } catch (error) {}
    },
    [selectedCategory, ButtonAction],
  );

  const OnChangeSubChildCategory = useCallback(
    async (e, text) => {
      try {
        setStepDIY(null);
        setLinkUrl("");
        setuploadImage(null);
        setCouponCode("");
        setSelectedPartner("");
        setChannelPartners(null);
        setformFieldAction(false); //Enabled/Disbled Submit Form while user select value
        setSelectedSubChildCategory(e.target.value);
        const parentCategoryId = selectedCategory;
        const CategoryId = selectedSubCategory;
        const SubSubCategoryId = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        if (e.target.value === getConfig.coupon_Code_Not_Working) {
          setLinkUrl("");
          setStepDIY(null);
          setSelectedCouponfield(true);
        } else {
          setSelectedCouponfield(false);

          await GetChannelpartners(
            parentCategoryId,
            CategoryId,
            SubSubCategoryId,
            "",
            "",
          );
        }
        setSelectedSubChildCategoryText(text);
        let dataLayerJson = {
          event: "help_subsubcategory",
          help_link: window.location.href,
          help_category: selectedCategoryText,
          help_subcategory: selectedSubCategoryText,
          help_subsubcategory: text,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
      } catch (error) {}
    },
    [
      selectedCategory,
      selectedSubCategory,
      selectedSubCategoryText,
      selectedCategoryText,
      selectedSubChildCategoryText,
    ],
  );

  const GetChannelpartners = useCallback(
    async (
      parentCategoryId,
      categoryId,
      subSubCategoryId,
      channelPartner,
      SubCategorytext,
    ) => {
      try {
        const payload = {
          parentCategoryId: parentCategoryId,
          categoryId: categoryId,
          subSubCategoryId: subSubCategoryId,
          channelPartner: channelPartner,
        };
        const ChannelPartnerResponse =
          await ChannelPartnerService?.current.ChannelPartners(payload);

        if (ChannelPartnerResponse.data.responseList != null) {
          setChannelPartners(ChannelPartnerResponse.data);
          setStepDIY(null);
        } else {
          setButtonAction(Enums.Yes_NO);
          await setvalidaty(
            channelPartner,
            parentCategoryId,
            categoryId,
            subSubCategoryId,
            mno,
          );
        }
      } catch (error) {}
    },
    [stepDIY, mno, sid, getConfig],
  );

  const ConfirmYesButtonOnclick = (e) => {
    e.preventDefault();
    window.location.href =
      getConfig.notAuth_redirectUrl || "https://www.vzy.one/";
  };
  const ConfirmNOButtonOnclick = useCallback(
    async (e) => {
      e.preventDefault();
      setformFieldAction(true);
      setStepDIY(null);
      setChannelPartners(null);
      setSelectedCouponfield(false);
      setLinkUrl("");
      setCouponCode("");
      let dataLayerJson = {
        event: "help_no",
        help_link: window.location.href,
        help_subsubcategory: selectedSubChildCategoryText,
        help_category: selectedCategoryText,
        help_subcategory: selectedSubCategoryText,
        channel_partner: selectedPartner,
      };
      if (a_t && mno !== 0 && sid) {
        dataLayerJson.user_type = userDetails.UserCategory;
        dataLayerJson.ott_sms_id = sid;
        dataLayerJson.platform = userDetails.Platform;
      }
      handleIPLGTMTaggingOnLanding(dataLayerJson);
    },
    [
      selectedCategoryText,
      selectedSubCategoryText,
      selectedSubChildCategoryText,
      selectedPartner,
      sid,
      mno,
    ],
  );

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    Subject: Yup.string()
      .matches(/[a-zA-Z]/, "Subject must contain at least one letter")
      .min(5, "Subject must be at least 5 characters.")
      .max(100, "Subject must be at most 100 characters.")
      .required("Subject is required"),
    Category: Yup.string().required("Category is required"),
    SubCategory: Yup.string().required("Sub Category is required"),
    description: Yup.string()
      .min(20, "Description must be at least 20 characters long.")
      .matches(/[a-zA-Z]/, "Description must contain at least one letter")

      .max(300, "Description must be at most 300 characters")
      .required("Description is required"),
  });

  const SubmitOnclick = (event, resetForm) => {
    confirmDialog({
      header: "Confirmation",
      message: "Are you sure you want to submit?",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => submitconfrim(event, resetForm),
    });
  };

  const submitconfrim = useCallback(
    async (values, resetForm) => {
      let dec;
      try {
        if (mno !== "") {
          dec =
            selectedPartner !== null
              ? values.description +
                "&lt;br /&gt;Content Partner - " +
                selectedPartner +
                "&lt;br /&gt;Mobile Number - " +
                mno
              : values.description + "&lt;br /&gt;Mobile Number - " + mno;
        } else {
          dec =
            selectedPartner !== null
              ? values.description +
                "&lt;br /&gt;Content Partner - " +
                selectedPartner
              : values.description;
        }
        const mail = eid !== null && eid !== "" ? eid : values.email;

        const OttSMSId = sid;
        const uploadImages = uploadImage;
        const formData = new FormData();
        formData.append("OttSMSId", OttSMSId ?? "");
        formData.append("Category", values.CategoryText);
        formData.append("CategoryId", values.Category);
        formData.append("ParentCategoryId", values.SubCategory);
        formData.append(
          "SubCategory",
          values.SubCategoryText + " !^) " + values.SubChildCategoryText,
        );
        formData.append("MailForm", mail);
        formData.append("MailId", mail);
        formData.append("Subject", values.Subject);
        formData.append("ComplainDetails", dec);
        formData.append("file", uploadImages ?? "");
        const response =
          await SubmitWatchoComplainFeedbackService?.current.SubmitWatchoComplainAndFeedback(
            formData,
          );
        let dataLayerJson = {
          event: "help_submit_ticket",
          help_link: window.location.href,
          help_subsubcategory: values.SubChildCategoryText,
          help_category: values.CategoryText,
          help_subcategory: values.SubCategoryText,
          channel_partner: selectedPartner,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails?.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails?.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
        if (response.resultCode === 200) {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: response.resultMessage,
            life: 3000,
            className: "Contactpage-toast",
          });
        } else {
          toast.current?.show({
            severity: "error",
            summary: "",
            detail: response.resultMessage,
            life: 3000,
            className: "Contactpage-toast",
          });
        }
        setuploadImage(null);
        resetForm();
        setSelectedCouponfield(false);
        setCategory(null);
        setIsDisabled(false);
        setformFieldAction(false); //Enabled/Disbled Submit Form while user select dropdown
        setChannelPartners(null);
        setStepDIY(null);
        setLinkUrl("");
        setSubCategory(null);
        setSubChildCategory(null);
        setIsDisabled(true);
        GetCategoryList();
      } catch (error) {}
    },
    [
      sid,
      eid,
      category,
      subCategory,
      selectedPartner,
      uploadImage,
      userDetails,
    ],
  );
  const searchCoupon = useCallback(async () => {
    try {
      const payload = {
        OTTSMSID: sid,
        CouponCode: couponCode,
      };
      const response =
        await SearchValidateCouponService?.current.ValidateCoupon(payload);

      if (response.data.responseList[0].isValid == "0") {
        if (
          response.data.responseList[0].purchasedBy.toLowerCase() === "amazon"
        ) {
          showDialog("error", response.data.responseList[0].resultMessage);
          setTypebutton("error");
          setVisible(true);
        } else {
          showDialog("error", response.data.responseList[0].resultMessage);

          setTypebutton("error");
          setVisible(true);
        }
      } else {
        setButtonAction("");
        showDialog("success", response.data.responseList[0].resultMessage);
        setVisible(true);
      }
      setValidateCoupon(response.data);
      setButtonAction(Enums.Yes_NO);
    } catch (error) {}
  }, [couponCode, sid]);
  const setvalidaty = useCallback(
    async (
      e,
      selectedCategory,
      selectedSubCategory,
      selectedSubChildCategory,
      mobileno,
    ) => {
      setPurchasedBy("");
      const CheckPlan = await GetOTTPlan(e, mobileno);

      if (CheckPlan?.type !== undefined) {
        // if (selectedPartner !== "") {
        if (CheckPlan?.type === 1) {
          setTypebutton("success");
          setbuttonColor("success");
          if (
            selectedSubCategory == getConfig.amount_Debited
          ) ////83:Amount Debited from Bank account but still subscription not Assigned
          {
            showDialog(
              "success",
              getConfig.payment_Active
                .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                .replace(
                  "{{appdate}}",
                  CheckPlan?.Date
                    ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                    : "",
                ),
            );
            setVisible(true);
          } else if (
            selectedSubCategory == getConfig.stop_Auto_Renewal
          ) //Stop Auto Renewal
          {
            setButtonAction("");
            showDialog(
              "success",
              CheckPlan.PurchasedBy === "Amazon"
                ? getConfig.stop_Auto_Renewal_Amazon_Message
                : getConfig.stop_Auto_Renewal_Watcho_Message,
            );
            setPurchasedBy(CheckPlan.PurchasedBy);
            setVisible(true);
          } else {
            setButtonAction(Enums.Yes_NO);
            if (e === "") {
              if (
                selectedSubCategory === getConfig.coupon_code_not_received
              ) //Coupon code not received
              {
                const payloadCoupon = { OTTSMSID: sid };

                const availableCouponResponse =
                  await SearchAvailableCouponService?.current.AvailableCoupon(
                    payloadCoupon,
                  );

                let couponCodes = "";
                if (availableCouponResponse.data !== null) {
                  couponCodes = (
                    availableCouponResponse.data.responseList || []
                  )
                    .map((coupon) => coupon.couponCode) // correct property name here
                    .join(", ");
                  const payload = {
                    parentCategoryId: selectedCategory,
                    categoryId: selectedSubCategory,
                    subSubCategoryId: selectedSubChildCategory,
                    channelPartner: e,
                  };
                  const SetpDIYresponse =
                    await SetpDIYService?.current.SetpDIYS(payload);
                  const data = SetpDIYresponse.data;

                  data.diySteps = data.diySteps.replace(
                    "{{cuoponcodes}}",
                    couponCodes ?? "",
                  );
                  showDialog("success", data.diySteps);
                  setTypebutton("success");
                } else {
                  showDialog(
                    "error",
                    getConfig.coupon_code_not_received__DeActive_Message,
                  );
                }
              } else {
                if (
                  selectedSubCategory ===
                    getConfig.unable_to_Redeem_Coupon_code ||
                  selectedCategory === getConfig.product_Service_Enquiry
                ) {
                  setButtonAction("");
                } else if (
                  selectedSubChildCategory === getConfig.multiple_Deduction
                ) {
                  setButtonAction("");
                  setformFieldAction(true);
                }
                const payload = {
                  parentCategoryId: selectedCategory,
                  categoryId: selectedSubCategory,
                  subSubCategoryId: selectedSubChildCategory,
                  channelPartner: e,
                };
                const SetpDIYresponse =
                  await SetpDIYService?.current.SetpDIYS(payload);
                const data = SetpDIYresponse.data;
                // Assuming diySteps is a string property inside data
                data.diySteps = data.diySteps
                  .replace(
                    "{{appdate}}",
                    CheckPlan?.Date
                      ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                      : "",
                  )
                  .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                  .replace("{{appduration}}", CheckPlan?.Duation ?? "");
                // Now data.diySteps contains the replaced string
                setStepDIY(data);
              }
            } else {
              showDialog(
                "success",
                getConfig.active
                  .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                  .replace(
                    "{{appdate}}",
                    CheckPlan?.Date
                      ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                      : "",
                  )
                  .replace("{{channel}}", e),
              );
            }
          }
          // Then set it in state
        } else if (CheckPlan?.type === 0 || CheckPlan?.type === 3) {
          if (
            selectedSubCategory == getConfig.amount_Debited
          ) ////83:Amount Debited from Bank account but still subscription not Assigned
          {
            showDialog(
              "error",
              CheckPlan.type === 0
                ? getConfig.payment_DeActive
                    .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                    .replace(
                      "{{appdate}}",
                      CheckPlan?.Date
                        ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                        : "",
                    )
                : getConfig.subscribeNotActive,
            );
            setTypebutton("error");
            setVisible(true);
          } else if (
            selectedSubCategory == getConfig.stop_Auto_Renewal
          ) //Stop Auto Renewal
          {
            setButtonAction("");
            if (e === "") {
              setbuttonColor("danger");
              showDialog(
                "error",
                CheckPlan.type === 0
                  ? getConfig.non_Channel_D_Active_Message
                      .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                      .replace(
                        "{{appdate}}",
                        CheckPlan?.Date
                          ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                          : "",
                      )
                  : getConfig.subscribeNotActive,
              );
              setVisible(true);
              setTypebutton("error");
            } else {
              setbuttonColor("danger");
              showDialog(
                "error",
                CheckPlan.PurchasedBy === "vzy"
                  ? getConfig.stop_Auto_Renewal_Watcho_Message
                  : getConfig.stop_Auto_Renewal_Amazon_Message,
              );
              setVisible(true);
            }
          } else {
            if (e === "") {
              if (
                selectedSubCategory === getConfig.coupon_code_not_received
              ) //Coupon code not received
              {
                const payloadCoupon = { OTTSMSID: sid };

                const availableCouponResponse =
                  await SearchAvailableCouponService?.current.AvailableCoupon(
                    payloadCoupon,
                  );

                let couponCodes = "";
                if (availableCouponResponse.data !== null) {
                  couponCodes = (
                    availableCouponResponse.data.responseList || []
                  )
                    .map((coupon) => coupon.couponCode) // correct property name here
                    .join(", ");
                  const payload = {
                    parentCategoryId: selectedCategory,
                    categoryId: selectedSubCategory,
                    subSubCategoryId: selectedSubChildCategory,
                    channelPartner: e,
                  };
                  const SetpDIYresponse =
                    await SetpDIYService?.current.SetpDIYS(payload);
                  const data = SetpDIYresponse.data;

                  data.diySteps = data.diySteps.replace(
                    "{{cuoponcodes}}",
                    couponCodes ?? "",
                  );
                  showDialog("success", data.diySteps);
                  setTypebutton("success");
                } else {
                  showDialog(
                    "error",
                    getConfig.coupon_code_not_received__DeActive_Message,
                  );
                  setTypebutton("error");
                  setbuttonColor("danger");
                }
              } else if (selectedSubCategory === getConfig.refund_Related) {
                setbuttonColor("danger");
                showDialog(
                  "error",
                  CheckPlan.type === 0
                    ? getConfig.payment_DeActive
                        .replace(
                          "{{appamount}}",
                          CheckPlan?.Amount ??
                            "Dear user there is no vzy subscription activated on your account",
                        )
                        .replace(
                          "{{appdate}}",
                          CheckPlan?.Date
                            ? new Date(CheckPlan.Date).toLocaleDateString(
                                "en-GB",
                              )
                            : "",
                        )
                        .replace("{{channel}}", e)
                    : getConfig.subscribeNotActive,
                );
                setVisible(true);
                setTypebutton("error");
              } else {
                if (
                  selectedSubCategory ===
                    getConfig.unable_to_Redeem_Coupon_code ||
                  selectedCategory === getConfig.product_Service_Enquiry
                ) {
                  setButtonAction("");
                }

                const payload = {
                  parentCategoryId: selectedCategory,
                  categoryId: selectedSubCategory,
                  subSubCategoryId: selectedSubChildCategory,
                  channelPartner: e,
                };
                const SetpDIYresponse =
                  await SetpDIYService?.current.SetpDIYS(payload);
                const data = SetpDIYresponse.data;
                // Assuming diySteps is a string property inside data
                data.diySteps = data.diySteps
                  .replace(
                    "{{appdate}}",
                    CheckPlan?.Date
                      ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                      : "",
                  )
                  .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                  .replace("{{appduration}}", CheckPlan?.Duation ?? "");
                // Now data.diySteps contains the replaced string
                setStepDIY(data);
              }
            } else {
              setbuttonColor("danger");
              showDialog(
                "error",
                CheckPlan.type === 0
                  ? getConfig.d_Active
                      .replace("{{appamount}}", CheckPlan?.Amount ?? "")
                      .replace(
                        "{{appdate}}",
                        CheckPlan?.Date
                          ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                          : "",
                      )
                      .replace("{{channel}}", e)
                  : getConfig.subscribeNotActive,
              );
              setVisible(true);
              setTypebutton("error");
            }
          }
        } else if (CheckPlan?.type === 2) {
          setbuttonColor("danger");
          showDialog(
            "error",
            getConfig.slub
              .replace("{{appamount}}", CheckPlan?.Amount ?? "")
              .replace(
                "{{appdate}}",
                CheckPlan?.Date
                  ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                  : "",
              )
              .replace("{{channel}}", e),
          );
          setVisible(true);
          setTypebutton("error");
          setButtonAction(Enums.Yes_NO);
        }
      } else {
        setbuttonColor("danger");
        showDialog("error", getConfig.subscribeNotActive);
        setVisible(true);
        setTypebutton("error");
      }
    },
    [sid, getConfig],
  );

  const OnChangeChannelpartner = useCallback(
    async (e) => {
      try {
        setStepDIY(null);
        setLinkUrl("");
        setSelectedPartner(e.target.value);
        const parentCategoryId = selectedCategory;
        const CategoryId = selectedSubCategory;
        const SubSubCategoryId = selectedSubChildCategory;

        await setvalidaty(
          e.target.value,
          parentCategoryId,
          CategoryId,
          SubSubCategoryId,
          mno,
        );
        let dataLayerJson = {
          event: "help_channel_partner",
          help_link: window.location.href,
          help_subsubcategory: selectedSubChildCategoryText,
          help_category: selectedCategoryText,
          help_subcategory: selectedSubCategoryText,
          channel_partner: e.target.value,
        };
        if (a_t && mno !== 0 && sid) {
          dataLayerJson.user_type = userDetails.UserCategory;
          dataLayerJson.ott_sms_id = sid;
          dataLayerJson.platform = userDetails.Platform;
        }
        handleIPLGTMTaggingOnLanding(dataLayerJson);
      } catch (error) {
        console.error("Error in OnChangeChannelpartner:", error);
      }
    },
    [
      selectedCategoryText,
      selectedSubCategoryText,
      selectedSubChildCategoryText,
      selectedPartner,
      selectedCategory,
      selectedSubCategory,
      selectedSubChildCategory,
      mno,
      getConfig,
    ],
  );

  const GetOTTPlan = useCallback(
    async (contentPartnerName, mobileno) => {
      try {
        const payload = { SearchBy: "MobileNo", SearchValue: mobileno };
        const OTTSubscribersresponse =
          await OTTSubscribersService?.current.OTTSubscriberList(payload);
        if (OTTSubscribersresponse?.data?.responseList === null) {
          return null;
        }
        const activeSubscribers =
          OTTSubscribersresponse.data?.responseList?.filter(
            (subscriber) => subscriber.statusOfService === "Active",
          ) ?? [];

        const matchingSubscribers = activeSubscribers.filter(
          (subscriber) =>
            Array.isArray(subscriber.subscriptionDetails) &&
            subscriber.subscriptionDetails.some((detail) =>
              detail.contentPartnerName?.includes(contentPartnerName),
            ),
        );
        const latestSubscriber = activeSubscribers.reduce((latest, current) => {
          const latestDate = new Date(latest.actualStartFrom);
          const currentDate = new Date(current.actualStartFrom);
          return currentDate > latestDate ? current : latest;
        }, activeSubscribers[0]);

        const ExpiredSubscribers =
          OTTSubscribersresponse.data?.responseList?.filter(
            (subscriber) => subscriber.statusOfService === "Expired",
          ) ?? [];
        const ExpiredmatchingSubscribers = ExpiredSubscribers.filter(
          (subscriber) =>
            Array.isArray(subscriber.subscriptionDetails) &&
            subscriber.subscriptionDetails.some((detail) =>
              detail.contentPartnerName?.includes(contentPartnerName),
            ),
        );
        if (activeSubscribers.length > 0 && matchingSubscribers.length > 0) {
          return {
            Amount: latestSubscriber.subscriptionPriceWithTax,
            Date: latestSubscriber.actualStartFrom,
            Duation: latestSubscriber.duration,
            PurchasedBy: latestSubscriber.purchasedBy,
            type: 1,
          };
        } else if (activeSubscribers.length > 0) {
          return {
            Amount: latestSubscriber.subscriptionPriceWithTax,
            Date: latestSubscriber.actualStartFrom,
            Duation: latestSubscriber.duration,
            PurchasedBy: latestSubscriber.purchasedBy,
            type: 2,
          };
        } else if (ExpiredSubscribers.length > 0) {
          return {
            Amount: ExpiredSubscribers[0].subscriptionPriceWithTax,
            Date: ExpiredSubscribers[0].actualStartFrom,
            Duation: ExpiredSubscribers[0].duration,
            PurchasedBy: ExpiredSubscribers[0].purchasedBy,
            type: 0,
          };
        } else {
          return {
            Amount: "",
            Date: "",
            Duation: "",
            DisplayName: "",
            type: 3,
          };
        }
      } catch (error) {}
    },
    [selectedCategory, selectedSubCategory, selectedSubChildCategory],
  );
  const DeActiveSteps = useCallback(
    async (type) => {
      setbuttonColor("");
      setLinkUrl("");
      setStepDIY(null);
      setVisible(false);
      let htmlString = "";
      if (selectedSubCategory == getConfig.amount_Debited && type == "error") {
        setButtonAction("");
        setformFieldAction(true);
        setLinkUrl(getConfig.amountDebit_DeActive);
      } else if (
        selectedSubCategory == getConfig.amount_Debited &&
        type == "success"
      ) {
        setLinkUrl(getConfig.amountDebit_Active);
      } else if (
        selectedSubCategory == getConfig.stop_Auto_Renewal &&
        type == "error"
      ) {
        setLinkUrl(getConfig.watcho_StepDIY);
      } else if (
        selectedSubCategory == getConfig.stop_Auto_Renewal &&
        type == "success"
      ) {
        setLinkUrl(
          purchasedBy === "Amazon"
            ? getConfig.amazon_StepDIY
            : getConfig.watcho_StepDIY,
        );
      } else if (
        selectedSubChildCategory == getConfig.coupon_Code_Not_Working &&
        type == "success"
      ) {
        setLinkUrl(getConfig.expired_Consumed_Valid);
      } else if (
        selectedSubChildCategory == getConfig.coupon_Code_Not_Working &&
        type == "error"
      ) {
        setLinkUrl(getConfig.dish_d2h_Not_Expired_Consumed_Valid);
      } else if (
        selectedSubChildCategory === getConfig.multiple_Deduction &&
        type == "error"
      ) {
        setButtonAction("");
        setformFieldAction(true);

        const CheckPlan = await GetOTTPlan(selectedPartner, mno);
        const payload = {
          parentCategoryId: selectedCategory,
          categoryId: selectedSubCategory,
          subSubCategoryId: selectedSubChildCategory,
          channelPartner: selectedPartner,
        };
        const SetpDIYresponse = await SetpDIYService?.current.SetpDIYS(payload);
        const data = SetpDIYresponse.data;
        if (data !== null) {
          // Assuming diySteps is a string property inside data
          data.diySteps = data.diySteps
            .replace(
              "{{appdate}}",
              CheckPlan?.Date
                ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                : "",
            )
            .replace("{{appamount}}", CheckPlan?.Amount ?? "")
            .replace("{{appduration}}", CheckPlan?.Duation ?? "");
          // Now data.diySteps contains the replaced string
          setStepDIY(data);
        }
      } else if (selectedSubCategory === getConfig.refund_Related) {
        const CheckPlan = await GetOTTPlan(selectedPartner, mno);
        const payload = {
          parentCategoryId: selectedCategory,
          categoryId: selectedSubCategory,
          subSubCategoryId: selectedSubChildCategory,
          channelPartner: selectedPartner,
        };
        const SetpDIYresponse = await SetpDIYService?.current.SetpDIYS(payload);
        const data = SetpDIYresponse.data;
        if (data !== null) {
          // Assuming diySteps is a string property inside data
          data.diySteps = data.diySteps
            .replace(
              "{{appdate}}",
              CheckPlan?.Date
                ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                : "",
            )
            .replace("{{appamount}}", CheckPlan?.Amount ?? "")
            .replace("{{appduration}}", CheckPlan?.Duation ?? "");
          // Now data.diySteps contains the replaced string
          setStepDIY(data);
        }
      } else if (
        selectedSubCategory === getConfig.coupon_code_not_received &&
        (type == "error" || type === "success")
      ) {
        const htmlString = `<p>Steps To Follow (DIY) :</p>
    <br/>
  <p>
    <font color="#000000" face="Times New Roman" size="3">
      <span>Step 1</span>&#160;
    </font>

    <font face="Times New Roman">
      <span>
       If your are expecting coupon from Amazon/Paytm. Please get in touch with CC team of respective teams.
      </span>
    </font>
  </p>
  </p>`;
        setLinkUrl(htmlString);
      } else if (type == "error") {
        htmlString = getConfig.gotoOTTPlans;
        setLinkUrl(htmlString);
      } else {
        const CheckPlan = await GetOTTPlan(selectedPartner, mno);
        const payload = {
          parentCategoryId: selectedCategory,
          categoryId: selectedSubCategory,
          subSubCategoryId: selectedSubChildCategory,
          channelPartner: selectedPartner,
        };
        const SetpDIYresponse = await SetpDIYService?.current.SetpDIYS(payload);
        const data = SetpDIYresponse.data;
        if (data !== null) {
          // Assuming diySteps is a string property inside data
          data.diySteps = data.diySteps
            .replace(
              "{{appdate}}",
              CheckPlan?.Date
                ? new Date(CheckPlan.Date).toLocaleDateString("en-GB")
                : "",
            )
            .replace("{{appamount}}", CheckPlan?.Amount ?? "")
            .replace("{{appduration}}", CheckPlan?.Duation ?? "");
          // Now data.diySteps contains the replaced string
          setStepDIY(data);
        }
      }
    },

    [
      selectedPartner,
      selectedCategory,
      mno,
      selectedSubCategory,
      selectedSubChildCategory,
      getConfig,
    ],
  );

  //************************ */ Ticket ***********************/
  const onUploadFile = useCallback(
    async (e) => {
      const file = e.target.files?.[0];

      if (file && file.type.startsWith("image/")) {
        setImage(URL.createObjectURL(file)); // now works ✅
        setuploadImage(file);
      } else {
        setImage(null);
        toast.current?.show({
          severity: "error",
          summary: "",
          detail: "Please upload only image files.",
          life: 3000,
          className: "Contactpage-toast",
        });
      }
    },
    [uploadImage],
  );

  const Auth = useCallback(async (MobileNo, OTTSMSID, Source, AuthToken) => {
    const payload = { MobileNo, OTTSMSID, Source, AuthToken };
    const response = await AuthValidateService?.current.Auth(payload);

    if (response.data) {
      GetCategoryList();
    } else {
      window.location.href = getConfig.notAuth_redirectUrl;
    }
    return response;
  });

  const GetUserDetails = useCallback(
    async (mobileNo, a_t) => {
      const userDetailCommand = {
        IsMobileVerified: true,
        MobileNo: mobileNo.toString(),
      };
      const apiBaseURL =
        (process.env.REACT_APP_API_URL || `${window.location.origin}`) +
        "/api/";

      const url = apiBaseURL + END_URL.UniFiedAPPS;
      try {
        const response = await axios.post(url, userDetailCommand, {
          headers: {
            "Content-Type": "application/json",
            Authorization: a_t,
          },
        });

        const json = response.data;
        if (json.resultCode === 0 && json.result) {
          const eid =
            json.result.EmailID && json.result.EmailID.trim() !== ""
              ? json.result.EmailID
              : "";

          const Platform =
            json.result.Platform && json.result.Platform !== null
              ? json.result.Platform
              : "Web";

          const UserCategory =
            json.result.CustomerCategory === 1
              ? "Dish"
              : json.result.CustomerCategory === 2
                ? "D2H"
                : json.result.CustomerCategory === 3
                  ? "vzy"
                  : "SITI";

          const userData = { Platform, UserCategory, EmailID: eid };

          setUserDetails(userData); // ✅ Store data in state
          return userData; // ✅ Return data if needed for chaining
        } else {
          console.warn("Unexpected API response:", json);
          return null;
        }
      } catch (error) {
        console.error("GetUserDetails error:", error);

        if (error.response?.data?.resultDesc) {
          // Optionally show a snackbar or toast
          console.warn(error.response.data.ResultDesc);
        } else {
          console.warn("Oops, something went wrong.");
        }

        return null;
      }
    },
    [userDetails],
  );

  return {
    formFieldAction,
    isDisabled,
    setIsDisabled,
    selectedCategory,
    category,
    OnChangeCategory,
    subCategory,
    subChildCategory,
    selectedSubCategory,
    selectedSubChildCategory,
    OnChangeSubCategory,
    stepDIY,
    ConfirmYesButtonOnclick,
    ConfirmNOButtonOnclick,
    SubmitOnclick,
    validationSchema,
    ChannelPartners,
    selectedPartner,
    OnChangeChannelpartner,
    ButtonAction,
    tabHelpActive,
    tabTicketActive,
    watchoTabOnclick,
    WatchoComplaint,
    image,
    onUploadFile,
    toast,
    setSubChildCategory,
    OnChangeSubChildCategory,
    linkUrl,
    selectedOTTPlans,
    oTTPlans,
    selectedCouponfield,
    AvailableCoupon,
    searchCoupon,
    couponCode,
    setCouponCode,
    visible,
    setVisible,
    dialogData,
    setDialogData,
    DeActiveSteps,
    typebutton,
    selectedSorcefield,
    buttonColor,
  };
};
